var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.close)?_c('div',{staticClass:"loading_component_area"},[_c('div',{staticClass:"loading_component_content"},[_c('div',{staticClass:"loader-03"}),_vm._v(" "),_c('div',{staticClass:"loading_component_tips"},[_vm._v("\n            "+_vm._s(_vm.tips)+"\n        ")])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fc8c4e9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading/index.vue
// module id = null
// module chunks = 